import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircleIcon } from '@heroicons/react/24/outline';
import Logo from '../components/Logo';

const InvitationDeclinedPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const name = searchParams.get('name') || '';

  useEffect(() => {
    // Redirect to home after 5 seconds
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <Logo size="medium" showCompanyName={true} />
        </div>
        
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <XCircleIcon className="h-16 w-16 text-red-500 mx-auto mb-4" />
          
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Invitation Declined
          </h1>
          
          <p className="text-gray-600 mb-6">
            {name ? `Thank you ${name}. ` : ''}We've noted that you won't be able to attend.
          </p>
          
          <p className="text-sm text-gray-500 mb-6">
            If you change your mind, please contact the event organizer.
          </p>
          
          <div className="bg-gray-50 rounded-md p-4">
            <p className="text-sm text-gray-600">
              You will be redirected to the homepage in a few seconds...
            </p>
          </div>
          
          <button
            onClick={() => navigate('/')}
            className="mt-6 px-6 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
          >
            Go to Homepage
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvitationDeclinedPage;